'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGE_TYPE_ID = exports.MESSAGE_TYPE_ID = '@type';

var LAST_SEEN = exports.LAST_SEEN = 'LAST_SEEN';
var OFFLINE = exports.OFFLINE = 'OFFLINE';
var INITIAL_MESSAGE = exports.INITIAL_MESSAGE = 'INITIAL_MESSAGE';
var CLOSE_CHANNEL = exports.CLOSE_CHANNEL = 'CLOSE_CHANNEL';
var OPEN_CHANNEL = exports.OPEN_CHANNEL = 'OPEN_CHANNEL';
var BLOCK = exports.BLOCK = 'BLOCK';
var CHAT_MESSAGE = exports.CHAT_MESSAGE = 'CHAT_MESSAGE';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/constants/PubNubMessageTypes.js
// module id = 23
// module chunks = 0 1